import React from "react";
import { Button } from "antd";
import "./MainButton.scss";

export default function MainButton(props) {
  // eslint-disable-next-line react/prop-types
  const { buttonType, ...otherProps } = props;
  switch (buttonType) {
    case "main":
      return (
        <Button className="button-submit" type="link" {...otherProps}></Button>
      );
    case "sub":
      return (
        <Button className="button-sub" type="link" {...otherProps}></Button>
      );
    default:
      return (
        <Button className="button-submit" type="link" {...otherProps}></Button>
      );
  }
  //   return (
  //     <>
  //     {/* {
  //       buttonType === 'main' ? <Button className="button-submit" type="link" {...otherProps} ></Button> : <Button className="button-resend" type="link" {...otherProps} ></Button>
  //     } */}
  //     {

  //     }
  //     </>
  //   )
}
